module.exports = __webpack_public_path__ + "img/excel-download1x.bee19ad3.png";